import { useMemo } from 'react';
import { useUIStore } from 'store/uiStore';
import { ToastOptions } from 'types/index';
import { TOAST_DURATION } from 'constants/index';

export const useToast = () => {
  const { showToast, toasts, removeToast } = useUIStore();

  const toast = useMemo(
    () => ({
      success: (message: string, title?: string) => {
        showToast({
          type: 'success',
          message,
          title,
          duration: TOAST_DURATION.MEDIUM,
        });
      },

      error: (message: string, title?: string) => {
        showToast({
          type: 'error',
          message,
          title,
          duration: TOAST_DURATION.LONG,
        });
      },

      warning: (message: string, title?: string) => {
        showToast({
          type: 'warning',
          message,
          title,
          duration: TOAST_DURATION.MEDIUM,
        });
      },

      info: (message: string, title?: string) => {
        showToast({
          type: 'info',
          message,
          title,
          duration: TOAST_DURATION.MEDIUM,
        });
      },

      custom: (options: ToastOptions) => {
        showToast(options);
      },
    }),
    [showToast]
  );

  return {
    toast,
    toasts,
    removeToast,
  };
};

